define('lq/storage',[],function () {
    'use strict';

    return {

        localStorageIsAvailable: function() {
            try {
                localStorage.setItem('test', 'test');
                localStorage.removeItem('test');
                return true;
            } catch (e) {
                return false;
            }
        }

    };
});

